import { kCanvasRightClickWidth } from "../constants";
import { commonInitMenu2 } from "./commonInitMenu2";

export function commonInitMenu(dropDown, wsMgr, numRows, x, y) {
  commonInitMenu2(dropDown, wsMgr, numRows, x, y, kCanvasRightClickWidth);
}
